/**
 * @generated SignedSource<<bfa6248920f28bf8d001ef6f211e6966>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeasurementAssetKind = "hydrant" | "valve" | "general_asset" | "%future added value";
export type MeasurementDataKind = "number" | "percentage" | "text" | "%future added value";
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type CreateMeasurementTemplateInput = {
  name: string;
  dataKind: MeasurementDataKind;
  assetKind: MeasurementAssetKind;
  clientMutationId?: string | null;
};
export type createPageCreateMeasurementTemplateMutation$variables = {
  input: CreateMeasurementTemplateInput;
};
export type createPageCreateMeasurementTemplateMutationVariables = createPageCreateMeasurementTemplateMutation$variables;
export type createPageCreateMeasurementTemplateMutation$data = {
  readonly createMeasurementTemplate: {
    readonly measurementTemplate: {
      readonly id: string;
      readonly createdAt: any;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly fields: ReadonlyArray<{
        readonly fieldName: string;
        readonly message: string;
      }> | null;
    }>;
  } | null;
};
export type createPageCreateMeasurementTemplateMutationResponse = createPageCreateMeasurementTemplateMutation$data;
export type createPageCreateMeasurementTemplateMutation = {
  variables: createPageCreateMeasurementTemplateMutationVariables;
  response: createPageCreateMeasurementTemplateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateMeasurementTemplatePayload",
    "kind": "LinkedField",
    "name": "createMeasurementTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MeasurementTemplate",
        "kind": "LinkedField",
        "name": "measurementTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserFieldError",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fieldName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createPageCreateMeasurementTemplateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createPageCreateMeasurementTemplateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b77604ea76709b552a9ca4b89fa554c4",
    "id": null,
    "metadata": {},
    "name": "createPageCreateMeasurementTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation createPageCreateMeasurementTemplateMutation(\n  $input: CreateMeasurementTemplateInput!\n) {\n  createMeasurementTemplate(input: $input) {\n    measurementTemplate {\n      id\n      createdAt\n      name\n    }\n    errors {\n      code\n      fields {\n        fieldName\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "19d82554c50d10ae13f8d482c9f8c296";

export default node;
